import React from 'react';
import { ToggletipContext } from './context';

export const useToggletipContext = () => {
  const context = React.useContext(ToggletipContext);

  if (context == null) {
    throw new Error('Toggletip components must be wrapped in <Toggletip />');
  }

  return context;
};
